import { createLogic } from 'redux-logic'
import Api from '@app/api/groups'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_GROUPS_DEVICES } from '@app/constants/groups/groups'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { setGroupDevices } from '@app/actions/groups/groups'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'

const fetchGroupDevices = createLogic({
  type: SYNC_GROUPS_DEVICES,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token: AccessToken } } } = store.getState()
    dispatch(apiRequestSent(SYNC_GROUPS_DEVICES))
    Api.fetchDevices(AccessToken)
      .then((response) => {
        dispatch(setGroupDevices(response.data))
        dispatch(apiRequestDone(SYNC_GROUPS_DEVICES))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('fetchDevices failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchGroupDevices
